<template>
  <v-flex>
    <masav-file-details v-if="masavFile" :model="masavFile"></masav-file-details>
    <v-card class="mx-auto" flat :loading="loading">
      <div>
        <v-data-table
          :headers="headers"
          :items="masavFileRows"
          :item-class="row_classes"
          :options.sync="options"
          :server-items-length="totalAmount"
          :loading="loading"
          :header-props="{ sortIcon: null }"
          class="elevation-1"
        > 
          <template v-slot:item.masavFileRowID="{ item }"  >
            <v-checkbox v-if="selectable && item.isPayed"
              v-model="item.selected"
              @click="updateSelectedRows(item.selected, item.masavFileRowID)"
              :checked="existSelectedRows(item.masavFileRowID)" 
              :label="item.masavFileRowID.toString()"
            ></v-checkbox>
            <span v-else>{{ item.masavFileRowID }}</span>
          </template>
          <template v-slot:item.amount="{ item }">
            <b class="text-center">{{item.amount | currency(item.currency)}}</b>
          </template>
          <template v-slot:item.smsSent="{ item }">{{item.smsSent ? $t("Yes") : $t("No")}}</template>
          <template v-slot:item.paymentTransactionID="{ item }">
            <router-link
              v-if="item.$paymentTransactionID"
              class="primary--text"
              link
              :to="{name: 'Transaction', params: {id: item.$paymentTransactionID}}"
            >
              <small>{{item.paymentTransactionID | guid}}</small>
            </router-link>
          </template>
          <!-- <template v-slot:item.terminalName="{ item }">
          <router-link class="text-decoration-none" link :to="{name: 'EditTerminal', params: {id: item.terminalID}}">
            {{item.terminalName || item.terminalID}}
          </router-link>
          </template>-->
        </v-data-table>
      </div>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  components: {
    ReIcon: () => import("../../components/misc/ResponsiveIcon"),
    MasavFileDetails: () => import("../../components/details/MasavFileDetails"),
    EcList: () => import("../../components/ec/EcList")
  },
  props: {
    filters: {
      default: () => {
        return {
          notTransmitted: false
        };
      }
    },
    selectable: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  data() {
    return {
      totalAmount: 0,
      numberOfRecords: 0,
      headers: [],
      masavFileRows: [],
      masavFile: null,
      loading: false,
      options: {},
      selectedRows: [],
      pagination: {},
      masavFileRowsFilter: {
        ...this.filters,
        masavFileID: this.$route.params.id
      }
    };
  },
  watch: {
    options: {
      handler: async function() {
        await this.getDataFromApi();
      },
      deep: true
    }
  },
  async mounted() {
    this.masavFile = await this.$api.masavFiles.getMasavFile(
      this.$route.params.id
    );
    await this.getDataFromApi();
    await this.initThreeDotMenu();
  },
  methods: {
    async getDataFromApi() {
      if(this.loading) { return; }
      this.loading = true;
      let data = await this.$api.masavFiles.getRows({
        ...this.masavFileRowsFilter,
        ...this.options
      });
      if (!this.headers || this.headers.length === 0) {
          this.headers = data.headers;
          // this.headers = [...data.headers, { value: "actions", text: this.$t("Actions"), sortable: false  }];
        }
      this.totalAmount = data.numberOfRecords;
      this.masavFileRows = data.data;
      this.numberOfRecords = data.numberOfRecords;
      this.loading = false;
    },
    async applyFilter(filter) {
      this.options.page = 1;
      this.masavFileRowsFilter = filter;
      await this.getDataFromApi();
    },
    async initThreeDotMenu(){
      this.$store.commit("ui/changeHeader", {
        value: {
          threeDotMenu: [
            {
              text: this.$t("RemoveSelected"),
              fn: async () => await this.removeSelected()
            }
            , 
            {
              text: this.$t("RemoveAll"),
              fn: async () => await this.removeAll()
            }
          ]
        }
      });
    },
    async removeAll(){
      await this.$api.masavFiles.removeRows({
        masavFileID: this.masavFileRowsFilter.masavFileID,
        masavFileRowIDs: this.masavFileRows.map(i => i.masavFileRowID)
      }
      );

      this.masavFileRows.forEach(element => {
        element.selected = false;
      });
      this.selectedRows = [];

      await this.getDataFromApi(false);
    },
    async removeSelected(){
      if(!this.selectedRows.length){
        return this.$toasted.show(this.$t("SelectRowsFirst"), { type: "error" });
      }
     
      await this.$api.masavFiles.removeRows({
        masavFileID: this.masavFileRowsFilter.masavFileID,     
        masavFileRowIDs: this.selectedRows
      }
      );

      this.masavFileRows.forEach(element => {
        element.selected = false;
      });
      this.selectedRows = [];

      await this.getDataFromApi(false);
    },
    row_classes(item) {
        if (!item.isPayed) {
          return "removed";
        } 
    },
    updateSelectedRows(selected, id) {
        if (selected && !this.selectedRows.includes(id)) {
          this.selectedRows.push(id);
        } else if (!selected && this.selectedRows.includes(id)) {
          this.selectedRows.splice(this.selectedRows.indexOf(id), 1);     
        }
    },
    existSelectedRows(id) {
      if (this.selectedRows.includes(id)) {
        this.updateMasavFileRows(id);
      }
      return this.selectedRows.includes(id);
    },
    updateMasavFileRows(id) {
      if (this.masavFileRows.filter((t) => t.masavFileRowID === id).length > 0) {
        this.masavFileRows.filter((t) => t.masavFileRowID === id)[0].selected = true;
      }
    }
  },
  computed: {
    canLoadMore() {
      return (
        this.numberOfRecords > 0 &&
        this.masavFileRowsFilter.take + this.masavFileRowsFilter.skip <
          this.numberOfRecords
      );
    }
  },
};
</script>

<style lang="scss" scoped>
.button {
  font-size: 0.9375rem;
}
</style>